import React from "react";
//#region types
import { QuotationWizardQuickSelectionProps } from "models/propTypes/quotationPropTypes";
import { TranslationKeys } from "translations";
import { HTMLConstants } from "utils/constants";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { InlineLabelDatePicker } from "components/common";
import { Portal } from "@mui/material";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const QuotationWizardQuickSelection: React.FC<QuotationWizardQuickSelectionProps> = (props) => {
  const { connect } = props;
  const quickSelectionMount = document.getElementById(HTMLConstants.WizardQuickSelectionPortalId);

  const invoiceDateProps = connect("otherSettings.invoiceDate");
  const dueDateProps = connect("otherSettings.dueDate");

  return (
    <Portal container={quickSelectionMount}>
      <Grid container item direction="row">
        <InlineLabelDatePicker
          {...invoiceDateProps}
          onChange={(date?: Date) => invoiceDateProps.setValue(date, true)}
          label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Quotation.QuotationDate)}
        />
        <InlineLabelDatePicker
          {...dueDateProps}
          onChange={(date?: Date) => dueDateProps.setValue(date, true)}
          label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Quotation.ExpirationDate)}
        />
      </Grid>
    </Portal>
  );
};

export default QuotationWizardQuickSelection;
